import React, { useState, useEffect, useRef } from "react";
import { getFullName } from "utils";
import { Field } from "formik";
import ReactSelectWithFormik from "components/lib/Shared/DropdownSelect";

function AlternateDirectorsForm(props) {
  const { form, directors } = props;
  let setFieldValue = null;
  if (props.setFieldValue) {
    setFieldValue = props.setFieldValue;
  } else if (form.setFieldValue) {
    setFieldValue = form.setFieldValue;
  }
  // Correct destructuring
  const [selectedAppointers, setSelectedAppointers] = useState([]);
  const dropdownRef = useRef(null);

  const getDirectorOptions = () => {
    return directors.map((director) => ({
      value: director._id,
      label:
        director.idType === "Local Company"
          ? director.names.companyName
          : getFullName(director.names),
    }));
  };

  const handleDirectorSelect = (name) => (option) => {
    const selectedDirectors = Array.isArray(option)
      ? option.map(({ value }) => value)
      : option?.value
      ? [option?.value]
      : [];
    setFieldValue(name, selectedDirectors);
    setSelectedAppointers(option);
  };

  return (
    <form className="mt-4">
      <div className="px-4 py-6 mt-2 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md">
        <div className="col-span-6 sm:col-span-3">
          <label
            htmlFor="designation"
            className="block text-sm font-medium text-gray-700"
          >
            Select below at least one appointer
          </label>

          <Field
            onChange={handleDirectorSelect("appointers")}
            name="appointers"
            component={ReactSelectWithFormik}
            options={getDirectorOptions()}
            value={selectedAppointers}
            placeholder="Select appointers"
            id="appointers"
            isMulti
          />
        </div>
      </div>
    </form>
  );
}

export default AlternateDirectorsForm;
